import React, { Component } from "react";
import { connect } from "react-redux";
import {
  List,
  Loader,
  Dimmer,
  Segment,
  Header,
  Message,
} from "semantic-ui-react";

import LastResultItem from "./Items/LastResultItem";
import Pagination from "../../utils/Pagination";
import OrdersFilter from "../filters/OrdersFilter";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  font: {
    fontSize: "16px",
    fontWeight: "bold",
  },
};

const options = [
  { key: "1", text: "10 por página", value: 10 },
  { key: "2", text: "20 por página", value: 20 },
  { key: "3", text: "50 por página", value: 50 },
  { key: "4", text: "100 por página", value: 100 },
];

class EntityOrdersList extends Component {
  state = {
    paginatedItems: [],
    itemsPerPage: 10,
    filteredOrders: [],
    allOrders: true,
  };

  onChangePage = (e) => {
    this.setState({
      paginatedItems: e,
    });
  };

  onInputChange = (e) => {
    const filter = e.target.value;

    if (filter.length > 2) {
      const filteredOrders = this.props.entityOrders.filter((order) => {
        if (order.paciente.indexOf(filter.toUpperCase()) !== -1) {
          return order;
        } else if (order.cedula.indexOf(filter) !== -1) {
          return order;
        } else if (order.orden.indexOf(filter) !== -1) {
          return order;
        }
      });
      this.setState({ filteredOrders, allOrders: false });
    } else {
      this.setState({ filteredOrders: [], allOrders: true });
    }
  };

  render() {
    const { entityOrders, entityOrdersLoading, selectedEntity } = this.props;
    const {
      paginatedItems,
      itemsPerPage,
      allOrders,
      filteredOrders,
    } = this.state;
    let listItems = [];
    // console.log(this.props.entityOrders, "this.props.entityOrders");
    listItems = paginatedItems.map((patient, index) => {
      return (
        <LastResultItem
          patient={patient}
          key={patient.orden}
          showPatientOrderResults={this.props.showPatientOrderResults}
        />
      );
    });

    return (
      <div>
        {entityOrdersLoading ? (
          <Dimmer active inverted>
            <Loader>Cargando...</Loader>
          </Dimmer>
        ) : (
          <div>
            {entityOrders.length === 0 ? (
              <Message
                info
                icon="info"
                header="Aún no tiene resultados asociados a su perfil."
              />
            ) : (
              <Segment>
                <Header as="h1">Resultados de {selectedEntity}</Header>
                <OrdersFilter
                  onInputChange={this.onInputChange}
                  placeholder="Búsqueda por número de orden, nombre del paciente o número de identificación"
                />

                <List divided verticalAlign="middle" size="large">
                  {listItems}
                </List>
                <Pagination
                  items={allOrders ? entityOrders : filteredOrders}
                  itemsPerPage={itemsPerPage}
                  onChangePage={this.onChangePage}
                  options={options}
                />
              </Segment>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default EntityOrdersList;
